import { configure, default as SentryFetch } from "@amzn/sentry-fetch";

/**
 * This service will be used to ensure Midway authentication is performed while trying to fetch
 * API resources
 */
export class BaseService {
  protected sentryFetch: typeof SentryFetch;
  protected baseUrl: string;

  constructor(baseUrl: string) {
    this.sentryFetch = configure({
      debug: false,
      followMidwayStepUp: true,
      failOnInvalidSession: true,
      preserveRedirectUri: true,
    });
    this.baseUrl = baseUrl;
  }

  public async fetch(fullPath: string, init?: RequestInit): Promise<Response> {
    const normalizedPath = fullPath.startsWith("/") ? fullPath : `/${fullPath}`;
    const url = `${this.baseUrl}${normalizedPath}`;

    return await this.sentryFetch(url, {
      credentials: "include",
      mode: "cors",
      ...init,
    });
  }
}